import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse, ProperHttpParamEncoder } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContentTreeModel } from 'app/generated/backend/content/api/content-tree-model';

@Injectable()
export class ContentTreeHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		languageIso2: string,
		uri: string,
		access: number,
		depth: number
	): Observable<JsonResourceResponse<ContentTreeModel>> {
		let params = new HttpParams({ encoder: new ProperHttpParamEncoder() });
		if (languageIso2!==null && languageIso2!==undefined) {
			params = params.set('languageIso2', languageIso2);
		}
		if (uri!==null && uri!==undefined) {
			params = params.set('uri', uri);
		}
		if (access!==null && access!==undefined) {
			params = params.set('access', access.toString());
		}
		if (depth!==null && depth!==undefined) {
			params = params.set('depth', depth.toString());
		}
		return this.http.get<JsonResourceResponse<ContentTreeModel>>('api/content/contentTree/translation', { params }).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ContentTreeHandlerService
	]
})
export class ContentTreeHandlerModule { }
